export default {
    root: {
        borderColor: '{content.border.color}'
    },
    content: {
        background: '{content.background}',
        color: '{text.color}'
    },
    horizontal: {
        margin: '1.125rem 0',
        padding: '0 1.125rem',
        content: {
            padding: '0 0.625rem'
        }
    },
    vertical: {
        margin: '0 1.125rem',
        padding: '1.125rem 0',
        content: {
            padding: '0.625rem 0'
        }
    }
};
